import { axiosLib } from '@/lib/axios';
import { showToast } from '@/services/toast-service';
import { getColocApiCallProperties } from '@/lib/coloc-api';
import type { DiscountFormData } from '../../types/discount';

export const useCreateDiscount = (contractId: number, refreshDiscounts: () => Promise<void>) => {
  const createDiscount = async (data: DiscountFormData) => {
    try {
      const formData = new FormData();
      formData.append('discount[amount]', data.amount.toString());
      formData.append('discount[measurement]', data.unit === '€' ? 'absolute' : 'percent');
      formData.append('discount[period]', data.period);
      formData.append('discount[note]', data.note || '');
      formData.append('discount[discount_category]', data.discount_category.toString());

      if (data.period === 'recurring') {
        if (data.startDate)
          formData.append('discount[start_date]', data.startDate.toISOString().split('T')[0]);
        if (data.endDate)
          formData.append('discount[end_date]', data.endDate.toISOString().split('T')[0]);
      }

      if (data.attachments && data.attachments.length > 0) {
        data.attachments.forEach((file: File) => {
          formData.append('discount[attachments][]', file);
        });
      }

      const response = await axiosLib.post(`/admin/contracts/${contractId}/discounts`, formData, {
        ...getColocApiCallProperties(),
        headers: {
          ...getColocApiCallProperties().headers,
          'Content-Type': 'multipart/form-data',
        },
      });

      if (response.data && response.data.success) {
        await refreshDiscounts();
        showToast.success({ text: response.data.success_message || 'Discount created!' });
        return true;
      } else {
        showToast.error({ text: response.data.error_message || 'Failed to create discount.' });
        return false;
      }
    } catch (error: any) {
      showToast.error({
        text: error.response?.data?.error_message || 'Failed to create discount.',
      });
      return false;
    }
  };

  return { createDiscount };
};
